import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessAdminComponent } from './access-admin/access-admin.component';
import { AppPropertiesService, AppPropertyComponentsModule, CommonLayoutModule } from '@sdbn/common';



@NgModule({
  declarations: [
    AccessAdminComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    AppPropertyComponentsModule
  ]
})
export class AccessAdminModule {

  constructor(
    private appPropertiesService: AppPropertiesService
  ) {

    // appPropertiesService.registerAppPropertiesAdminComponent('sample', AccessAdminComponent);


  }

}
